import { render, staticRenderFns } from "./ContMyBusinessTermsComponent.vue?vue&type=template&id=693bfad8&scoped=true&lang=pug"
import script from "./ContMyBusinessTermsComponent.vue?vue&type=script&lang=js"
export * from "./ContMyBusinessTermsComponent.vue?vue&type=script&lang=js"
import style0 from "./ContMyBusinessTermsComponent.vue?vue&type=style&index=0&id=693bfad8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693bfad8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('693bfad8')) {
      api.createRecord('693bfad8', component.options)
    } else {
      api.reload('693bfad8', component.options)
    }
    module.hot.accept("./ContMyBusinessTermsComponent.vue?vue&type=template&id=693bfad8&scoped=true&lang=pug", function () {
      api.rerender('693bfad8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/my_objects/components/ContMyBusinessTermsComponent.vue"
export default component.exports